module.exports = __webpack_public_path__ + "img/iphone-charging-POLAND-pl.39372885.webp";